// API configuration
const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
const viteApiBase = import.meta.env.VITE_API_BASE || ''
const viteWsBase = import.meta.env.VITE_WS_BASE || ''

export const API_BASE = viteApiBase || (isDev 
  ? 'http://localhost:8787'  // Local Worker dev server
  : '')  // Hosted environments use same-origin relative URLs by default.

export const WS_BASE = viteWsBase || (isDev
  ? 'ws://localhost:8787'
  : '')  // Hosted environments use same-origin WebSockets by default.
